<template>
    <div class="m-sms-modal-keyboard sms-modal-keyboard">
        <AKeyboardKey
            v-for="(button, index) in keyboardKeys"
            :key="index"
            :item="button"
            @onClick="onClick"
        />
    </div>
</template>

<script>
import AKeyboardKey from '../../atoms/a-keyboard-key/a-keyboard-key';

import { KEYS } from './m-sms-modal-keys';

export default {
    name: 'MSmsModalKeyboard',
    components: {
        AKeyboardKey
    },
    data() {
        return {
            keyboardKeys: KEYS
        }
    },
    methods: {
        onClick(e) {
            this.$emit('onClick', e);
        }
    }
}
</script>

<style lang="scss">
@import "m-sms-modal-keyboard";
</style>
